import React from 'react'
import { logos } from '../../assets'

export const AlertNoMobile = () => {
    return (
        <div className='fixed top-0 w-full h-full bg-1B1464'>
            <div className='w-full h-full flex flex-col justify-center items-center'>
                <img className='mb-4' src={logos.inmersysLogin} alt="" />
                <p className='text-white font-bold text-xl text-center py-4 w-[320px]' >Inmersys XR Training no esta disponible en dispositivos móviles.</p>
                <p className='text-white font-normal text-base text-center w-[320px]' >Puedes utilizar nuestra aplicación de escritorio para acceder a tu cuenta.</p>
            </div>
        </div>
    )
}
